<template>
  <form class="ws-modal" @submit.prevent="submit">
    <div class="ws-modal__form">
      <header class="ws-modal__header">
        <h2 class="has-text-weight-bold is-size-1">
          <span v-if="isClone" v-text="$t('Клонировать группу')"></span>
          <span v-else-if="isNewItem" v-text="$t('Добавить группу')"></span>
          <span v-else v-text="$t('Редактировать группу')"></span>
        </h2>
      </header>
      <div class="ws-modal__content" :class="{'is-loading':isPending}">
        <div class="columns is-multiline">
          <ws-request-exam-group-form
            :complexityLevel="exam.accred_comps.complexity_level"
            :exam="exam"
            :values="newItem"
            :deleteGroupRow="deleteGroupRow"
            ref="validateForm"
          />
        </div>
      </div>
      <footer class="ws-modal__footer">
        <div class="columns">
          <div class="column is-8"></div>
          <div class="column is-4 is-vcentered">
            <div class="has-text-right-desktop">
              <button class="ws-button button is-large is-primary is-fullwidth" type="submit" :class="{'is-loading':isPending}">
                <span v-if="isClone" class="is-size-4 has-text-weight-bold" v-text="$t('Клонировать группу')"></span>
                <span v-else-if="isNewItem" class="is-size-4 has-text-weight-bold" v-text="$t('Добавить группу')"></span>
                <span v-else class="is-size-4 has-text-weight-bold" v-text="$t('Редактировать группу')"></span>
              </button>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <aside class="ws-modal__sidebar">
      <button
        type="button"
        class="ws-button button is-text"
        @click="close"
      >
        <ws-icon
          class="ws-button__icon"
          name="close-thin"
          color="#000000"
          :fill="true"
          :title="$t('Закрыть')"
          width="17"
          height="18"
        />
      </button>
    </aside>
  </form>
</template>

<script>
import moment from 'moment'
import cloneDeep from 'lodash/cloneDeep'
import { mapActions, mapState } from 'vuex'
import WsRequestExamGroupForm from '../WsRequestExamGroupForm.vue'
import { defaultGroupState } from '@/utils/getDefaultGroupState'
import { constants } from '@/services/constants.service'

export default {
  name: 'WsRequestExamsChooseGroup',
  components: { WsRequestExamGroupForm },
  props: {
    exam: {
      type: Object
    },
    shift: {
      type: Object
    },
    isClone: {
      type: Boolean
    }
  },
  data () {
    return {
      config: __config,
      newItem: {
        groups: [
          defaultGroupState({ exam: this.exam })
        ],
        shift: {},
        job_issued_at: null,
        started_at: null,
        ended_at: null,
        number: 1
      },
      group: {
        value: null,
        guid: null,
        list: []
      },
      deleteArrGroups: [],
      updated: [],
      day_cm1: new Date(this.exam.day_cm1),
      constants
    }
  },
  watch: {
    shift: {
      immediate: true,
      handler (item) {
        if (item) {
          const jobIssuedAt = this.shift ? moment(this.shift.job_issued_at).toDate() : new Date()
          const startedAt = this.shift ? moment(this.shift.started_at).toDate() : new Date()
          const endedAt = this.shift ? moment(this.shift.ended_at).toDate() : new Date()
          this.newItem = Object.assign({}, item, {
            job_issued_at: jobIssuedAt.getFullYear() <= 1910 ? new Date() : jobIssuedAt,
            started_at: startedAt.getFullYear() <= 1910 ? new Date() : startedAt,
            ended_at: endedAt.getFullYear() <= 1910 ? new Date() : endedAt,
            groups: cloneDeep(item.groups).map(el => {
              if (!el.region) {
                el.region = {
                  value: this.exam.de_center.address.region.title.display || '',
                  guid: this.exam.de_center.address.region.guid || null
                }
              }

              if (!el.institution) {
                el.institution = {
                  guid: this.exam.de_center.guid || null,
                  value: this.exam.de_center.name.translate.ru || ''
                }
              }
              return el
            })
          })
          if (this.isClone) {
            this.newItem.number++
          }
        }
      }
    }
  },
  computed: {
    ...mapState('exams/shifts', {
      isUpdatePending: 'isUpdatePending',
      isCreatePending: 'isCreatePending'
    }),
    ...mapState('public/refbook/region', {
      isRegionPending: 'isFindPending'
    }),
    isPending () {
      return this.isCreatePending || this.isUpdatePending
    },
    isNewItem () {
      return !(this.newItem && this.newItem.guid)
    }
  },
  methods: {
    ...mapActions('exams/shifts', ['update', 'create', 'remove']),
    ...mapActions('refbook/study_groups', {
      'findGroups': 'find'
    }),
    ...mapActions('public/refbook/region', {
      findRegion: 'find',
      getRegion: 'getRegion'
    }),

    deleteGroupRow (i) {
      const deleted = this.newItem.groups.splice(i, 1)
      if (deleted && deleted.length) {
        this.deleteArrGroups = this.deleteArrGroups.concat(deleted.map(d => d.guid))
      }
    },

    async submit () {
      let newShift = {}
      this.$validator.resume()
      const result = await this.$validator.validateAll() && await this.$refs.validateForm.$validator.validateAll()
      if (result) {
        try {
          if (this.isNewItem || this.isClone) {
            newShift = await this.create([{
              'number': this.newItem.number,
              'job_issued_at': this.newItem.job_issued_at,
              'started_at': this.newItem.started_at,
              'ended_at': this.newItem.ended_at
            }, `/${this.exam.guid}/shifts`])
          } else {
            newShift = await this.update([ this.exam.guid, {
              'number': this.newItem.number,
              'job_issued_at': this.newItem.job_issued_at,
              'started_at': this.newItem.started_at,
              'ended_at': this.newItem.ended_at
            }, `/shifts/${this.newItem.guid}` ])
          }

          for (let group of this.newItem.groups) {
            if (group.guid && !this.isClone) {
              const shiftGroup = this.shift.groups.find(g => {
                return g.guid === group.guid
              })
              if (shiftGroup.education_group.guid !== group.education_group.guid || shiftGroup.student !== group.student || shiftGroup.independent_estimate_participants_number !== group.independent_estimate_participants_number) {
                await this.update([ this.exam.guid, {
                  'shift': {
                    'guid': newShift.guid
                  },
                  'education_group': {
                    'guid': group.education_group.guid
                  },
                  'student': group.student,
                  'independent_estimate_participants_number': group.independent_estimate_participants_number
                }, `/shifts/${newShift.guid}/groups/${group.guid}` ])
              }
            } else {
              await this.create([{
                'shift': {
                  'guid': newShift.guid
                },
                'education_group': {
                  'guid': group.education_group.guid
                },
                'student': group.student,
                'independent_estimate_participants_number': group.independent_estimate_participants_number
              }, `/${this.exam.guid}/shifts/${newShift.guid}/groups` ])
            }
          }

          if (this.deleteArrGroups && this.deleteArrGroups.length) {
            await Promise.all(this.deleteArrGroups.map(guid => this.remove([
              this.exam.guid,
              {},
              `/shifts/${newShift.guid}/groups/${guid}`
            ])))
          }

          if (this.isNewItem) {
            this.$emit('onAddItem', newShift)
          } else {
            this.$emit('onUpdateItem', newShift)
          }

          this.close()
          this.$buefy.toast.open({
            message: this.$t(`Группы успешно добавлены.`),
            type: 'is-success'
          })
        } catch (e) {
          this.$buefy.toast.open({
            message: this.$t(`Что-то пошло не так :(`),
            type: 'is-danger'
          })
        }
      }
    },
    close () {
      this.$parent.close()
    }
  },
  mounted () {
    this.$validator.pause()
  }
}
</script>
<style scoped>
.ml-1 {
  margin-left: 1rem;
}

.group-region {
  margin-top: 1rem;
  display: block;
}
</style>
